import { useFormikContext } from 'formik';
import React from 'react';

import { scrollToWithNav } from '@containers/ScrollTo/scrollToWithNav';

interface IProps {
  name: string;
  inputRef: React.RefObject<HTMLInputElement>;
}

export const ScrollToError: React.FC<IProps> = ({ inputRef, name }) => {
  const { isValid, errors, submitCount } = useFormikContext();

  React.useEffect(() => {
    if (submitCount !== 0 && !isValid) {
      const [errorName] = Object.keys(errors);

      if (errorName === name) {
        if (inputRef?.current) {
          scrollToWithNav(inputRef.current.getBoundingClientRect().top + window.pageYOffset - 50);
          setTimeout(() => {
            if (inputRef?.current) inputRef.current.focus();
          }, 300);
        }
      }
    }
  }, [submitCount, isValid]);

  return null;
};
